import axios from "axios";

const baseUrl = "https://helpdesk.ncsa.or.th/hdt/api/v2/callcenters";

const params = {
  headers: {
    key: "defsgeERTHSwesfggar45wa2ge14hg53se4rhser",
  },
};

export const getSummaryChannel = async (data) => {
  const response = await axios.post(`${baseUrl}/summarychannel`, data, params);

  return response.data;
};

export const getSummaryCase = async (data) => {
  const response = await axios.post(`${baseUrl}/summarycase`, data, params);

  return response.data;
};
